import {IEpgItem} from "../interfaces/IEpgItem.ts";

export default class UtilsHelper {
    public static calcProgressBar(item: IEpgItem): string {
        if (item) {
            const now = Math.floor(new Date().getTime() / 1000);
            const totalTime = item.stop_timestamp - item.start_timestamp;
            const progress = now - item.start_timestamp;
            let percentage = (progress / totalTime) * 100;
            if (percentage <= 0)
                percentage = 0;
            return percentage + "%";
        }
        return "0%";
    }

    public static changeWindowDocumentTitleAndHistoryPath = (title: string, path: string) => {
        window.history.replaceState(
            null,
            `${title} - Beskid Media GO.pl`,
            path
        );
        document.title = `${title} - Beskid Media GO.pl`;
    }

    public static changeWindowDocumentTitle = (title: string) => {
        document.title = `${title} - Beskid Media GO.pl`;
    }
}